import { defaultApiState } from '@/store/types/general.types';
import { UserAttributeState } from '../admin/types/group-user-attribute.types';

export const userAttributeState: UserAttributeState = {
  isMissingAttributeValue: undefined,
  apiState: {
    getCurrentUserAttributeValueValidity: defaultApiState
  }
};
